window.OKJS = window.OKJS || {};
(function (OKJS) {
  let iso;
  const grid = document.querySelector('.js-magical-cards-wrapper');
  const filterButtons = document.querySelectorAll('.js-filter-button');
  const showAllButton = document.querySelector('.js-show-all-button');
  const showMoreButton = document.querySelector('.js-show-more-magical-layout');

  const spinner = document.querySelector('.js-magical-layout-spinner');
  const cardsFilterElement = document.querySelector(
    '.js-magical-layout-filter'
  );
  const cardsLinksElement = document.querySelector(
    '.js-magical-layout-card-wrapper'
  );

  const urlParams = new URLSearchParams(window.location.search);
  const filterValueFromUrl = urlParams.get('filter');

  OKJS.MagicalLayout = {
    init: function (hideFilterBool, defaultCategory, hideCurrentCardBool) {
      const hideFilter = hideFilterBool;
      let filterValue = defaultCategory;
      const hideCardOfCurrentPage = hideCurrentCardBool;

      if (hideFilter === true) {
        cardsLinksElement.classList.add(
          'magical-layout-card-wrapper--no-filter'
        );

        showMoreButton.addEventListener('click', function () {
          cardsLinksElement.classList.add(
            'magical-layout-card-wrapper--active'
          );
        });
      }

      //Skjul det pågældende kort, som linker til den aktuelle side man besøger
      if (hideCardOfCurrentPage === true) {
        const articleLinks = document.querySelectorAll('.js-card-item-link');

        articleLinks.forEach(function (link) {
          const articleHref = link.getAttribute('href');

          // Få stien efter den sidste skråstreg
          const articlePath = articleHref.substring(
            articleHref.lastIndexOf('/') + 1
          );

          // Få stien fra den aktuelle URL og fjern queries
          let currentPath = window.location.pathname.substring(
            window.location.pathname.lastIndexOf('/') + 1
          );
          const queryIndex = currentPath.indexOf('?');
          if (queryIndex !== -1) {
            currentPath = currentPath.substring(0, queryIndex);
          }

          // Sammenlign stierne
          if (currentPath === articlePath) {
            // Hent det tilsvarende kort element
            const articleElement = link.closest('.js-card-item');

            articleElement.parentNode.removeChild(articleElement);
          }
        });
      }

      // Initialisér Isotope
      iso = new Isotope(grid, {
        itemSelector: '.js-card-item',
        layoutMode: 'masonry',
      });

      filterButtons.forEach(function (filterButton) {
        filterButton.addEventListener('click', OKJS.MagicalLayout.applyFilter);
      });

      if (showAllButton) {
        showAllButton.addEventListener(
          'click',
          OKJS.MagicalLayout.showAllArticles
        );
      }

      //filter udfra query parameter
      if (filterValueFromUrl) {
        filterValue = filterValueFromUrl;
        OKJS.MagicalLayout.setupFilter('.' + filterValue);
      } else {
        OKJS.MagicalLayout.setupFilter(filterValue);
      }

      cardsLinksElement.classList.add('magical-layout-card-wrapper--loaded');
      if (cardsFilterElement) {
        cardsFilterElement.classList.add('magical-layout-filter--loaded');
      }
      spinner.classList.add('hidden');

      iso.layout();
    },

    showAllArticles: function (event) {
      filterValue = event.currentTarget.getAttribute('data-filter');
      OKJS.MagicalLayout.setupFilter(filterValue);

      if (showAllButton) {
        OKJS.MagicalLayout.scrollToAnchor(showAllButton);
      }
    },

    applyFilter: function (event) {
      filterValue = event.currentTarget.getAttribute('data-filter');
      OKJS.MagicalLayout.setupFilter(filterValue);
    },

    setupFilter: function (filterValue) {
      if (filterValue === '*') {
        iso.arrange({ filter: '*' });

        if (showAllButton) {
          showAllButton.classList.add(
            'magical-layout-card-wrapper__show-all--hidden'
          );
        }
      } else {
        iso.arrange({ filter: filterValue });

        if (showAllButton) {
          showAllButton.classList.remove(
            'magical-layout-card-wrapper__show-all--hidden'
          );
        }
      }

      filterButtons.forEach(function (filterButton) {
        filterButton.classList.remove('magical-layout-filter__button--active');
      });

      const activeFilterButton = document.querySelector(
        '.magical-layout-filter__button[data-filter="' + filterValue + '"]'
      );

      if (activeFilterButton) {
        activeFilterButton.classList.add(
          'magical-layout-filter__button--active'
        );

        const selectedFilter = document.querySelector('.js-selected-filter');
        const selectedFilterText = document.querySelector(
          '.js-selected-filter-text'
        );
        const filterText = activeFilterButton.getAttribute('data-filter-text');

        if (selectedFilter) {
          selectedFilterText.textContent = filterText;
          selectedFilter.classList.add(
            'magical-layout-filter__selected-filter--active'
          );

          if (filterValue === '*') {
            selectedFilter.classList.remove(
              'magical-layout-filter__selected-filter--active'
            );
          }
        }
      }
    },

    scrollToAnchor: function (showAllButton) {
      var dataAnchor = showAllButton.getAttribute('data-anchor');

      // Find element med ID på siden som der skal scrolles til
      var anchorTargetElement = document.getElementById(dataAnchor);

      if (anchorTargetElement) {
        // Beregn den ønskede rulleposition
        var scrollPosition =
          anchorTargetElement.getBoundingClientRect().top + window.scrollY;

        window.scrollTo({
          top: scrollPosition - 30,
          behavior: 'smooth',
        });
      }
    },
  };
})(window.OKJS);
